import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "account-notification"
}
const _hoisted_2 = ["href", "innerHTML"]

import { computed, ref } from "vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { cookieStore } from "@/shared/utils/store/use-store";
import InfoText from "./shared/info-text.vue";
import { userNotificationState } from "../use-user-account";
import { settings } from "@/settings";
import { isMobileApp } from "@/mobile-apps/mobile-app-integration";

const cookieName = "account-notification-closed";
const cookieDuration = 14; // 14 days


export default /*@__PURE__*/_defineComponent({
  __name: 'account-notification',
  setup(__props) {

const temporarilyClosed = ref(false);

const closePopup = () => {
    temporarilyClosed.value = true;
    cookieStore.set(cookieName, "true", { expires: cookieDuration });
};

const canOpen = computed(() => userNotificationState.value != "None");

const isPopupOpen = computed(
    () =>
        !isMobileApp &&
        canOpen.value &&
        window.location.pathname != settings.url.profile &&
        !cookieStore.get<boolean>(cookieName) &&
        !temporarilyClosed.value
);

const title = computed(() => {
    switch (userNotificationState.value) {
        case "FillInfo":
            return "Potřebujeme ještě pár údajů";
        case "VerifyEmail":
            return "Ověřit emailovou adresu";

        default:
            return "";
    }
});
const perex = computed(() => {
    switch (userNotificationState.value) {
        case "FillInfo":
            return "Nenechte si uniknout žádnou zajímavou nabídku a získejte možnost využít veškeré odměny i bonusy na maximum.";
        case "VerifyEmail":
            return "Ověřte si e-mail, aby vám už neunikla žádná zajímavá nabídka, odměna ani bonus.";

        default:
            return "";
    }
});
const buttonText = computed(() => {
    switch (userNotificationState.value) {
        case "FillInfo":
            return "Doplnit údaje";
        case "VerifyEmail":
            return "Ověřit email";

        default:
            return "";
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TransitionFade, null, {
    default: _withCtx(() => [
      (isPopupOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", {
              class: "account-notification__close",
              onClick: closePopup
            }),
            _createVNode(WebpImage, {
              class: "account-notification__logo",
              src: "/frontend/kasa-loyalty/img/static/logo.svg",
              alt: "Sazka logo",
              width: "82",
              height: "82"
            }),
            _createVNode(InfoText, {
              title: title.value,
              perex: perex.value,
              class: "account-notification__info-text"
            }, null, 8, ["title", "perex"]),
            _createElementVNode("a", {
              class: "account-notification__button btn btn-secondary",
              href: _unref(settings).url.profile,
              innerHTML: buttonText.value
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})